import styled from 'styled-components';

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const TableWrapper = styled.div`
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  overflow: hidden;
`;
